import axios from "axios";

const apiIntegrador = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_INTEGRADOR,
});

// As rotas do integrador (`/get-*-from-erp`) passaram a exigir token
// (commits `Feat: isAuthenticated` do backend) e respondiam "Acesso negado"
// na sincronização da lista de produtos. Diferente do `api`, esta instância
// nunca recebeu o header do AuthContext, então lemos o token direto do
// localStorage a cada requisição — assim vale também se a sincronização
// rodar antes de o contexto terminar de montar.
apiIntegrador.interceptors.request.use((config) => {
  const token = localStorage.getItem('@Aplication:token');

  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }

  return config;
});

export default apiIntegrador;
